export const FUNCTION_TYPES = {
	API_PACKAGE: 'APIPackage',
	CSHARP_FUNCTION: 'CSharpFunction',
	API_METHOD: 'APIMethod',
	JS_FUNCTION: 'JSFunction'
}